/**
 * Set the status of an invoice to 'UNPAID'.
 *
 * @param {Object} options - Options for setting the invoice status to 'UNPAID'.
 * @param {Function} options.dispatchAPI - Function to dispatch API requests.
 * @param {Function} options.message - Function to display error messages.
 * @param {string} options.id - The ID of the invoice to be updated.
 * @param {boolean} options.refreshData - The current state of the data refresh flag.
 * @param {Function} options.setRefreshData - Function to set the data refresh flag.
 * @returns {Promise<void>} A promise that resolves once the invoice status is updated successfully.
 */
export const setInvoiceStatusToUnpaid = async ({
  dispatchAPI,
  message,
  id,
  refreshData,
  setRefreshData
}) => {
  try {
    const formData = new FormData();
    const newBody = {
      status: 'UNPAID'
    };
    formData.append('values', JSON.stringify(newBody));

    await dispatchAPI('PATCH', {
      url: `customerinvoices/form/${id}`,
      body: formData
    });

    setRefreshData(!refreshData);
  } catch (e) {
    message(e);
  }
};
